import { Typography } from '@healingpaper/cell'
import styled from 'styled-components'

import CharacterJA from './assets/character_ja.svg'

import DownloadQrcode from '@/app/components/DownloadQrcode'
import FlexRow from '@/components/shared/FlexRow'
import { isWinterBrandCampaignPeriod } from '@/features/about/shared/utils/is-winter-brand-campaign-period'
import { useLocales } from '@/shared/hooks/useLocales'

const LargeDownloadBanner = () => {
  const { isLocale } = useLocales()

  const splashImageSrc = isWinterBrandCampaignPeriod()
    ? '/images/kr/winter-brand-campaign-2025-splash.png'
    : '/images/kr/splash.webp'

  return (
    <Container>
      {isLocale.JP && (
        <StyledContainer aria-label="download banner jp">
          <CharacterJA />
          <StyledQRCodeWrapper>
            <DownloadQrcode size={140} level="L" bgColor="transparent" />
          </StyledQRCodeWrapper>
        </StyledContainer>
      )}
      {isLocale.KR && (
        <StyledContainer aria-label="download banner kr">
          <img src={splashImageSrc} alt="2024 brand film" width="100%" height="auto" className="rounded-[16px]" />
          <FlexRow justify="space-between">
            <StyledTitle type="title2" className="flex-1">
              QR찍고 앱에서
              <br />더 자세히 보기
            </StyledTitle>
            <div aria-label="app download qr area" className="cursor-pointer">
              <DownloadQrcode size={140} level="L" bgColor="transparent" aria-label="app download qr code" />
            </div>
          </FlexRow>
        </StyledContainer>
      )}
    </Container>
  )
}

const Container = styled.div`
  position: fixed;
  width: 344px;
`

const StyledTitle = styled(Typography)`
  padding-left: 16px;
`

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const StyledQRCodeWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 108px;
`

export default LargeDownloadBanner
